import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaChevronRight, FaCheck, FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { message } from "antd";
import logoImage from '../../assets/image/jas-logo-wb.png';
import hostedBuyerBg from '../../assets/image/hosted-buyer-registration.png';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import useFetchData from '../../common/useFetchData';

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: '#D6A955',
    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(214, 169, 85, 0.25)' : null,
    backgroundColor: '#fff',
    '&:hover': {
      borderColor: '#D6A955'
    },
    minHeight: '38px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#D6A955' : state.isFocused ? 'rgba(214, 169, 85, 0.15)' : '#fff',
    color: state.isSelected ? '#fff' : '#000',
    '&:active': {
      backgroundColor: '#D6A955',
      color: '#fff'
    }
  })
};

const CustomDropdown = ({ title, items }) => {
  return (
    <NavDropdown
      title={<span className="custom-header-button">{title}</span>}
      id={`dropdown-${title.toLowerCase().replace(/\s/g, '-')}`}
      className="custom-dropdown"
    >
      {items.map((item, index) =>
        item.list ? (
          <div key={index} className="dropdown-submenu">
            <NavDropdown
              title={
                <span className="d-flex justify-content-between align-items-center w-100">
                  {item.text}
                  <FaChevronRight className="ml-2" />
                </span>
              }
              id={`sub-dropdown-${item.text.toLowerCase().replace(/\s/g, '-')}`}
              className="nested-dropdown"
            >
              {Object.entries(item.list).map(([key, value], i) => (
                <NavDropdown.Item key={i} href={value.link}>
                  {value.text}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
          </div>
        ) : (
          <NavDropdown.Item key={index} href={item.link}>
            {item.text}
          </NavDropdown.Item>
        )
      )}
    </NavDropdown>
  );
};

const BuyerRegistrationForm = ({ formStatus }) => {
  const { showData } = useFetchData();
  const [formData, setFormData] = useState({
    company: '',
    designation: '',
    name: '',
    mobile: '',
    email: '',
    city: '',
    address: '',
    pincode: '',
    country: 'India',
    state: '',
    gstNumber: '',
    gstCertificate: null,
    photo: null,
    idProofFront: null,
    idProofBack: null,

    arrivalFrom: '',
    arrivalDate: '',
    arrivalTime: '',
    arrivalMode: '',
    modeDetails: '',
    hotelCheckInDate: null,
    hotelCheckOutDate: null,

    stayDuration: '',

    requiresCab: '',
    departureDate: null,
    departureTime: null,
    departureMode: null,
    ticket: '',

    sameAddress: false,
    commAddress: '',
    commCity: '',
    commPincode: '',
    commState: '',
    exhibitor_one: '',
    exhibitor_two: '',
  });
  const [exhibitorList, setExhibitorList] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [dataPresent, setDataPresent] = useState({});
  const [showError, setShowError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [duplicateError, setDuplicateError] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const [gstTouched, setGstTouched] = useState(false);
  const [stayOption, setStayOption] = useState('');
  const [gstForm, setGstForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formStep, setFormStep] = useState(1);
  const [gstAdded, setGSTAdded] = useState(false);
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  const [isAlreadyApproved, setIsAlreadyApproved] = useState(false);
  const [nriOrIndian, setNriOrIndian] = useState('Indian');

  useEffect(() => {
    setIsSubmitAttempted(false);
    setEmailTouched(false);
    setGstTouched(false);
  }, [formStep]);

  useEffect(() => {
    const savedMobile = sessionStorage.getItem('buyerMobile');
    if (savedMobile) {
      sessionStorage.removeItem('buyerMobile');
      setFormData(prev => ({ ...prev, mobile: savedMobile }));
    }
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/exhibitor-lists-data`)
      .then((resData) => {
        if (resData.data && resData.data.data) {
          setExhibitorList(resData.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching exhibitor list:", error);
      });
  }, []);

  const [previews, setPreviews] = useState({
    photo: null,
    idProofFront: null,
    idProofBack: null,
    ticket: null,
  });

  const navItems = [
    {
      title: "HOME",
      type: "link",
      link: "https://jasjaipur.com"
    },
    {
      title: "ABOUT",
      type: "dropdown",
      items: [
        { text: "ABOUT JAS", link: "https://jasjaipur.com/about-jas/" },
        { text: "JEWELLERS ASSOCIATION", link: "https://jasjaipur.com/jewellers-asscoiation/" },
        { text: "COMMITTEE", link: "https://jasjaipur.com/committee/" }
      ]
    },
    {
      title: "VISITOR SERVICES",
      type: "dropdown",
      items: [
        { text: "BUYER'S GUIDE", link: "/visitor/registration" },
        {
          text: "TRAVLES AND HOTELS", list: [
            { text: "OFFICIAL HOTELS", link: "https://jasjaipur.com/official-hotels/" },
            { text: "AIR INFO", link: "https://jasjaipur.com/air-info/" },
            { text: "RAIL INFO", link: "https://jasjaipur.com/rail-info/" },
            { text: "ROAD INFO", link: "https://jasjaipur.com/road-info/" },
            { text: "RESTAURANT INFO", link: "https://jasjaipur.com/restaurant-info/" },
          ], link: "/visitor/information"
        },
        {
          text: "JAIPUR GUIDE", list: [
            { text: "AT A GLANCE", link: "https://jasjaipur.com/at-a-glance" },
            { text: "HISTORY", link: "https://jasjaipur.com/history" },
            { text: "TOURIST SPOTS", link: "https://jasjaipur.com/tourist-spots" },
          ], link: "/visitor/information"
        },
        { text: "VENUE", link: "/venue-location" }
      ]
    },
    {
      title: "EXHIBITOR SERVICES",
      type: "dropdown",
      items: [
        { text: "EXHIBITORS LOGIN", link: "/exhibitor/login" },
        { text: "EXHIBITORS LIST", link: "https://jasjaipur.com/exhibitors-list/" },
        { text: "FLOOR PLAN", link: "https://jasjaipur.com/floor-plan/" },
        { text: "EXHIBITOR MANUAL", link: "https://jasjaipur.com/wp-content/uploads/2026/04/exhibitor-manual.pdf" },
        {
          text: "BOOTH LAYOUT", list: [
            { text: "12 SQM JEWELLERY STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/12-Sqm-JEWELLERY-STALL.pdf" },
            { text: "24 SQM JEWELLERY STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/24-Sqm-JEWELLERY-STALL.pdf" },
            { text: "12 SQM GEMSTONE STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/12-Sqm-GEMSTONE-STALL.pdf" },
            { text: "24 SQM GEMSTONE STALL", link: "https://jasjaipur.com/wp-content/uploads/2024/05/24-Sqm-JEWELLERY-STALL.pdf" },
          ], link: "/exhibitor/booth"
        },
        { text: "SPONSORSHIP OPPORTUNITY", link: "https://jasjaipur.com/wp-content/uploads/2023/05/Sponsorship-Oppourtinity-for-jas-23.pdf" },
      ]
    },
    {
      title: "VISITOR REGISTRATION",
      type: "link",
      link: "/visitor-registration"
    },
    {
      title: "JE AWARDS",
      type: "link",
      link: "https://jasjaipur.com/JEAwards"
    },
    {
      title: "GALLERY",
      type: "link",
      link: "https://jasjaipur.com/gallery"
    },
    {
      title: "PRESS ROOM",
      type: "link",
      link: "https://jasjaipur.com/press-room"
    },
    {
      title: "CONTACT US",
      type: "link",
      link: "https://jasjaipur.com/contact-us"
    },
  ];

  const oneNightOptions = ["2nd July", "3rd July", "4th July", "5th July"];
  const twoNightOptions = [
    "2nd July - 4th July",
    "3rd July - 5th July",
    "4th July - 6th July",
    "5th July - 6th July",
  ];

  const isDateInvalid = (dateStr, isDeparture = false) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;
    const maxVal = isDeparture ? "2026-07-06" : "2026-07-05";
    return dateStr < "2026-06-30" || dateStr > maxVal;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "arrivalMode" && value === "Self") {
      setFormData(prevState => ({
        ...prevState,
        arrivalMode: value,
        modeDetails: '',
        ticket: null
      }));
      setPreviews(prev => ({
        ...prev,
        ticket: null
      }));
      setDataPresent(prev => ({
        ...prev,
        upload_ticket: null
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
    if (name === "country") {
      if (value && value.trim().toLowerCase() !== "india") {
        setNriOrIndian("NRI");
      } else {
        setNriOrIndian("Indian");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (file) {
      const allowedExtensions = name === 'ticket' ? ['png', 'jpg', 'jpeg', 'pdf'] : ['png', 'jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        message.error(`Only ${allowedExtensions.map(ext => ext.toUpperCase()).join(', ')} files are allowed.`);
        e.target.value = '';
        return;
      }

      setFormData(prevState => ({
        ...prevState,
        [name]: file
      }));

      const objectUrl = URL.createObjectURL(file);
      setPreviews(prev => ({ ...prev, [name]: objectUrl }));
    }
  };

  const renderPreview = (name, existingFile, folder) => {
    const preview = previews[name];
    if (!preview && !existingFile) return null;

    const fileUrl = preview ? preview : `${process.env.REACT_APP_IMAGE_URL || 'https://cdnjascrm.samaksh.in/media'}/${folder}/${existingFile}`;

    // Check if it's a PDF. For blob URLs, we check the formData to see if it's a PDF file
    let isPDF = false;
    if (preview && formData[name] instanceof File) {
      isPDF = formData[name].type === 'application/pdf';
    } else if (typeof fileUrl === 'string') {
      isPDF = fileUrl.toLowerCase().endsWith('.pdf') || fileUrl.startsWith('data:application/pdf');
    }

    return (
      <div className="mt-2">
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
          {isPDF ? (
            <div className="p-2 border rounded bg-light text-dark d-inline-flex align-items-center" style={{ cursor: 'pointer' }}>
              <span className="me-2">📄</span>
              <span>PDF Preview (Click to open)</span>
            </div>
          ) : (
            <img
              src={fileUrl}
              alt={`${name} preview`}
              className="img-thumbnail"
              style={{ maxHeight: '150px', cursor: 'pointer' }}
            />
          )}
        </a>
      </div>
    );
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      requiresCab: value
    });
  };

  const handleMobileNoChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/\D/g, "");

    setFormData({
      ...formData,
      [name]: numericValue,
    });

    if (numericValue.length === 10) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-phone-number-existance/${numericValue}`
        )
        .then((resData) => {
          if (resData.data.found) {
            setDuplicateError("true");
            message.error(`This mobile number is already registered`);
          } else {
            setDuplicateError(null);
          }
        })
        .catch((error) => {
          console.error('Error checking mobile:', error);
        });
    }
  };

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (value === "") {
      setEmailError("");
    } else if (!emailPattern.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleCommunicationAddress = (e) => {
    const isChecked = e.target.checked;

    setFormData({
      ...formData,
      sameAddress: isChecked,
      commAddress: isChecked ? formData.address : '',
      commCity: isChecked ? formData.city : '',
      commPincode: isChecked ? formData.pincode : '',
      commState: isChecked ? formData.state : '',
    });
  };

  const handleCheckNoIsPresentOrNot = (e, manualMobile = null) => {
    if (e) e.preventDefault();
    const mobileNumber = manualMobile || formData.mobile;

    if (!mobileNumber) return;

    try {
      setIsLoading(true);
      axios
        .post(
          `${process.env.REACT_APP_API_END_POINT}/check-no-is-present-in-buyer`,
          { number: mobileNumber }
        )
        .then((resData) => {
          if (!resData.data.status) {
            if (resData.data.message && resData.data.message.includes("Approved Hosted buyer")) {
              setIsLoading(false);
              return setIsAlreadyApproved(true);
            }
            setIsLoading(false);
            message.error(resData.data.message);
          } else {
            const data = resData.data.data;

            console.log('Res data: ', resData.data.data);

            if (data.approved_status === "true" || data.approved_status === true) {
              setIsLoading(false);
              return setIsAlreadyApproved(true);
            }

            setIsAlreadyApproved(false);

            setFormStep(1);

            setFormOpen(true);
            // setGstForm(true);

            setDataPresent(data);

            setStayOption(
              data.stayDuration === "2nd July" ||
                data.stayDuration === "3rd July" ||
                data.stayDuration === "4th July" ||
                data.stayDuration === "5th July" ||
                data.stayDuration === "3rd" ||
                data.stayDuration === "4th" ||
                data.stayDuration === "5th" ||
                data.stayDuration === "6th"
                ? "1"
                : data.stayDuration !== null && data.stayDuration !== ""
                  ? "2"
                  : ""
            );
            const normalize = (val) => String(val || "").trim().toLowerCase();

            if (data.country && data.country.toLowerCase() !== "india") {
              setNriOrIndian("NRI");
            } else {
              setNriOrIndian("Indian");
            }

            setFormData(prev => {
              const address = data.address || data.street_address || '';
              const city = data.city || '';
              const state = data.state || '';
              const pincode = data.pincode || data.postal_code || '';

              const commAddress = data.commAddress || '';
              const commCity = data.commCity || '';
              const commState = data.commState || '';
              const commPincode = data.commPincode || '';

              return {
                ...prev,
                company: data.company || data.company_name || '',
                designation: data.designation || '',
                name: data.visitor_name || '',
                mobile: data.mobile_number || '',
                email: data.email || '',
                city: city,
                address: address,
                country: data.country || 'India',
                gstNumber: data.gst_number || '',
                state: state,
                arrivalDate: data.arrivalDate !== "null" ? (data.arrivalDate || '') : '',
                arrivalTime: data.arrivalTime !== "null" ? (data.arrivalTime || '') : '',
                arrivalFrom: data.arrivalFrom !== "null" ? (data.arrivalFrom || '') : '',
                arrivalMode: data.arrivalMode !== "null" ? (data.arrivalMode || '') : '',
                modeDetails: data.modeDetails !== "null" ? (data.modeDetails || '') : '',
                requiresCab: data.requiresCab || '',
                departureDate: data.departureDate !== "null" ? (data.departureDate || '') : '',
                departureTime: data.departureTime !== "null" ? (data.departureTime || '') : '',
                departureMode: data.departureMode !== "null" ? (data.departureMode || '') : '',
                stayDuration: data.stayDuration || '',
                pincode: pincode,
                commAddress: commAddress,
                commCity: commCity,
                commPincode: commPincode,
                commState: commState,
                sameAddress: commAddress !== "" && commAddress !== "null" &&
                  normalize(commAddress) === normalize(address) &&
                  normalize(commCity) === normalize(city) &&
                  normalize(commState) === normalize(state) &&
                  normalize(commPincode) === normalize(pincode),
                exhibitor_one: data.exhibitor_one || '',
                exhibitor_two: data.exhibitor_two || '',
              };
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          message.error("An error occurred");
        });
    } catch (error) {
      message.error('Failed to check the number, Please try again later');
    }
  };

  const storeGstDetails = (e) => {
    e.preventDefault();

    if (
      !formData.company
      || !formData.mobile
      || !formData.city
      || !formData.address
      || !formData.pincode
      || !formData.country
      || (nriOrIndian === "Indian" && !formData.gstNumber)
      || !formData.state
    ) {
      return message.error('Please wait while we fetch your GST details');
    }

    const data = new FormData();
    data.append("_id", dataPresent._id);
    data.append("company_name", formData.company);
    data.append("country", formData.country);
    data.append("city", formData.city);
    data.append("postal_code", formData.pincode);
    data.append("gst_number", formData.gstNumber);
    data.append("street_address", formData.address);
    data.append("mobile_number", formData.mobile);
    data.append("state", formData.state);

    axios
      .post(
        `${process.env.REACT_APP_API_END_POINT}/add-addition-detail`,
        data,
        {
          headers: {
            barcode: dataPresent.barcode,
          },
        }
      )
      .then((resData) => {
        message.success("Hosted Buyer GST Details Saved Successfully");
        setFormOpen(true);
      })
      .catch((error) => {
        console.log('Error occurred while updating the buyer form:', error);
        message.error("Hosted Buyer Details Updation Failed, Please try again later");
      })
  };

  const handleSubmit = (e) => {
    setIsSubmitAttempted(true);

    if (e.currentTarget.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();

      setTimeout(() => {
        const firstError = document.querySelector('.text-danger');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);

      return;
    }
    e.preventDefault();
    setIsLoading(true);

    if (duplicateError) {
      message.error("This mobile number is already registered.");
      setIsLoading(false);
      return;
    }

    if (
      formStep === 1
      && (
        !formData.company
        || !formData.designation
        || !formData.name
        || !formData.mobile
        || !formData.email
        || !formData.city
        || !formData.address
        || !formData.pincode
        || !formData.country
        || (nriOrIndian === "Indian" && !formData.gstNumber)
        || !formData.state
        || !formData.exhibitor_one
        || !formData.exhibitor_two
      )
    ) {
      setIsLoading(false);
      return message.error('Please fill necessary details for buyer (Personal, GST/VAT, and Exhibitor details).');
    }

    if (formStep === 1 && formData.exhibitor_one === formData.exhibitor_two) {
      setIsLoading(false);
      return message.error('Exhibitor 1 and Exhibitor 2 cannot be the same.');
    }

    if (
      formStep === 2
      && (
        ((!formData.photo || formData.photo === null) && !dataPresent.photo)
        || ((!formData.idProofBack || formData.idProofBack === null) && !dataPresent.id_proof_back)
        || ((!formData.idProofFront || formData.idProofFront === null) && !dataPresent.id_proof_front)
      )
    ) {
      setIsLoading(false);
      return message.error('Please fill all the pictures.');
    }

    if (
      formStep === 3
      && (
        !formData.arrivalMode
        || !formData.stayDuration
        || !stayOption
        || (formData.arrivalMode !== 'Self' && !formData.ticket && !dataPresent.upload_ticket)
      )
    ) {
      setIsLoading(false);
      return message.error('Please fill all the travel details for the buyer.');
    }

    if (
      formStep === 3
      && (
        !formData.requiresCab
        || formData.requiresCab === ""
        || formData.requiresCab === "null"
      )
    ) {
      setIsLoading(false);
      return message.error('Please fill all the travel details for the buyer.');
    }

    if (
      formStep === 1
      && (
        !formData.commAddress
        || !formData.commCity
        || !formData.commPincode
        || !formData.commState
      )
    ) {
      setIsLoading(false);
      return message.error('Please fill all communcation address fields');
    }

    if (formStep === 3) {
      if (
        !formData.arrivalFrom
        || !formData.arrivalDate
        || !formData.arrivalTime
        || (formData.arrivalMode !== 'Self' && !formData.modeDetails)
      ) {
        setIsLoading(false);
        return message.error('Please fill all the arrival travel details');
      }

      if (
        formData.arrivalDate > "2026-07-05"
        || formData.arrivalDate < "2026-06-30"
      ) {
        setIsLoading(false);
        return message.error('Please select date between 30th June, 2026 - 5th July, 2026');
      }
    }

    if (formStep === 3 && formData.requiresCab === 'Yes') {
      if (
        !formData.departureDate
        || !formData.departureMode
        || !formData.departureTime
      ) {
        setIsLoading(false);
        return message.error('Please fill the departure details');
      }

      if (
        formData.departureDate > "2026-07-06"
        || formData.departureDate < "2026-06-30"
      ) {
        setIsLoading(false);
        return message.error('Please select date between 30th June, 2026 - 6th July, 2026');
      }
    }

    const data = new FormData();
    data.append("_id", dataPresent._id);
    data.append("visitor_name", formData.name);
    data.append("company_name", formData.company);
    data.append("country", formData.country);
    data.append("city", formData.city);
    data.append("postal_code", formData.pincode);
    data.append("state", formData.state);
    data.append("gst_number", formData.gstNumber);
    data.append("street_address", formData.address);
    data.append("mobile_number", formData.mobile);
    data.append("email", formData.email);
    data.append("designation", formData.designation);
    data.append("photo", formData.photo);
    data.append("id_proof_front", formData.idProofFront);
    data.append("id_proof_back", formData.idProofBack);
    data.append("gst_certificate", formData.gstCertificate);
    data.append("arrivalFrom", formData.arrivalFrom);
    data.append("arrivalDate", formData.arrivalDate);
    data.append("arrivalTime", formData.arrivalTime);
    data.append("arrivalMode", formData.arrivalMode);
    data.append("modeDetails", formData.modeDetails);
    data.append("hotelCheckInDate", formData.hotelCheckInDate);
    data.append("hotelCheckOutDate", formData.hotelCheckOutDate);
    data.append("requiresCab", formData.requiresCab);
    data.append("departureDate", formData.departureDate);
    data.append("departureTime", formData.departureTime);
    data.append("departureMode", formData.departureMode);
    data.append("stayDuration", formData.stayDuration);
    data.append("commAddress", formData.commAddress);
    data.append("commCity", formData.commCity);
    data.append("commPincode", formData.commPincode);
    data.append("commState", formData.commState);
    data.append("upload_ticket", formData.ticket);
    data.append("exhibitor_one", formData.exhibitor_one);
    data.append("exhibitor_two", formData.exhibitor_two);

    axios
      .post(
        `${process.env.REACT_APP_API_END_POINT}/add-addition-detail`,
        data,
        {
          headers: {
            barcode: dataPresent.barcode,
          },
        }
      )
      .then((resData) => {
        setIsLoading(false);
        if (formStep === 1) {
          message.success("Hosted Buyer Personal and GST Details Saved Successfully");
          setFormStep(2);
        } else if (formStep === 2) {
          message.success("Hosted Buyer Pictures Saved Successfully");
          setFormStep(3);
        } else {
          message.success("Hosted Buyer Travel Details Saved Successfully");

          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log('Error occurred while updating the buyer form:', error);
        message.error("Hosted Buyer Details Updation Failed, Please try again later");
      })
  };

  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  function checkRegex(input) {
    return regex.test(input);
  }

  function convertToUpperCase(input) {
    return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
  }

  const handleGstNumberChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: convertToUpperCase(value)
    }));

    if (nriOrIndian === "NRI") {
      setShowError("");
      return;
    }

    if (value === "") {
      setShowError("");
    } else if (checkRegex(value)) {
      setShowError("");
    } else {
      setShowError("Provide Valid GSTIN");
    }
  };

  useEffect(() => {
    if (nriOrIndian === "NRI") {
      return;
    }
    if (formData.gstNumber?.length === 15 && checkRegex(formData.gstNumber)) {
      setIsLoading(true);

      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${formData.gstNumber}`
        )
        .then((resData) => {
          setIsLoading(false);
          if (resData.data.flag === false) {
            setShowError(resData.data.message);
            return;
          }
          setShowError("");
          setGSTAdded(true);
          setFormData({
            ...formData,
            company: resData.data.company,
            address: resData.data.address,
            city: resData.data.city,
            pincode: resData.data.pincode,
            state: resData.data.state,
          });
        }).catch((err) => {
          setIsLoading(false);
          console.log("gst fetch validation ")
          setShowError("Facing Problem While Fetching")
          message.error('Error occurred while fetching GST details');
        })
    }
  }, [formData.gstNumber]);

  useEffect(() => {
    if (formData.stayDuration) {
      let checkIn = "";
      let checkOut = "";

      if (stayOption === "1") {
        if (formData.stayDuration === "2nd July") {
          checkIn = "2026-07-02";
          checkOut = "2026-07-03";
        } else if (formData.stayDuration === "3rd July") {
          checkIn = "2026-07-03";
          checkOut = "2026-07-04";
        } else if (formData.stayDuration === "4th July") {
          checkIn = "2026-07-04";
          checkOut = "2026-07-05";
        } else if (formData.stayDuration === "5th July") {
          checkIn = "2026-07-05";
          checkOut = "2026-07-06";
        }
      } else if (stayOption === "2") {
        if (formData.stayDuration === "2nd July - 4th July") {
          checkIn = "2026-07-02";
          checkOut = "2026-07-04";
        } else if (formData.stayDuration === "3rd July - 5th July") {
          checkIn = "2026-07-03";
          checkOut = "2026-07-05";
        } else if (formData.stayDuration === "4th July - 6th July") {
          checkIn = "2026-07-04";
          checkOut = "2026-07-06";
        } else if (formData.stayDuration === "5th July - 6th July") {
          checkIn = "2026-07-05";
          checkOut = "2026-07-06";
        }
      }

      setFormData((prev) => ({
        ...prev,
        hotelCheckInDate: checkIn,
        hotelCheckOutDate: checkOut,
      }));
    }
  }, [formData.stayDuration, stayOption]);

  return (
    <div className="visitor-registration-page">

      <div className="bg-amber-700 py-2">
        <Container fluid>
          <Row className="align-items-center">
            <Col xs={6} md={3} lg={2}>
              <Navbar.Brand href="https://jasjaipur.com" className="text-white d-flex align-items-center mr-5">
                <img src={logoImage} width={'150px'} />
              </Navbar.Brand>
            </Col>

            <Col xs={6} md={9} lg={10}>
              <Navbar expand="lg" className="p-0 justify-content-end">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                  <Nav>
                    {/* {navItems.map((item, index) => (
                      item.type === "dropdown" ? (
                        <CustomDropdown
                          key={index}
                          title={item.title}
                          items={item.items}
                        />
                      ) : (
                        <Nav.Link
                          key={index}
                          href={item.link}
                          className="custom-header-button"
                        >
                          {item.title}
                        </Nav.Link>
                      )
                    ))} */}

                    <Button
                      style={{ backgroundColor: 'rgb(33,37,41)', border: 'none' }}
                      onClick={() => window.location.href = 'https://jasjaipur.com'}
                    >
                      Go Back
                    </Button>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Col>
          </Row>
        </Container>

        <style jsx>{`
          .bg-amber-700 {
              background-color: #b98b51;
              height: 80px;
          }

          .navbar-expand-lg .navbar-nav {
              gap: 0px;
          }

          .custom-header-button {
              color: white;
              font-weight: 600;
              font-size: 14px;
          }

          .custom-header-button:hover {
              color: white;
          }

          .custom-dropdown .dropdown-toggle::after {
              color: white;
          }

          .custom-dropdown .dropdown-menu {
              border-radius: 0;
              margin-top: 0;
              border: none;
              box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }

          .nav-link, .dropdown-toggle {
              font-size: 0.85rem;
              letter-spacing: 0.5px;
          }

          .nav-link {
              font-weight: 600;
              font-size: 14px;
              margin-left: 10px;
          }

          .stepper-wrapper {
              position: relative;
              display: flex;
              justify-content: space-between;
              margin-bottom: 40px;
          }

          .stepper-item {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              flex: 1;
          }

          .stepper-item::before {
              position: absolute;
              content: "";
              border-bottom: 2px solid #666;
              width: 100%;
              top: 20px;
              left: -50%;
              z-index: 0;
          }

          .stepper-item:first-child::before {
              content: none;
          }

          .stepper-item.completed::before {
              border-color: #ffc107;
          }

          .step-counter {
              position: relative;
              z-index: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #666;
              margin-bottom: 10px;
              color: white;
              font-weight: bold;
              border: 2px solid #3a3a3a;
          }

          .stepper-item.active .step-counter {
              background-color: #ffc107;
              color: black;
              border-color: #ffc107;
          }

          .stepper-item.completed .step-counter {
              background-color: #ffc107;
              color: black;
              border-color: #ffc107;
          }

          .step-name {
              font-size: 13px;
              color: #000;
              font-weight: 500;
              text-align: center;
          }

          .stepper-item.active .step-name {
              color: #ffc107;
              font-weight: 600;
          }
        `}</style>
      </div>

      <div
        className="header-bg py-4"
        style={{
          backgroundImage: `url(${hostedBuyerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          height: '150px',
        }}
      >
        <Container>
          <h1 className="text-white mt-4 ms-n3" style={{ marginLeft: '-50px' }}>HOSTED BUYER REGISTRATION</h1>
          <div
            className="header-underline"
            style={{
              width: '230px',
              height: '3px',
              backgroundColor: '#ffc107',
              marginTop: '8px',
              marginLeft: '-50px',
            }}
          ></div>
        </Container>
      </div>

      {formStatus && (!showData || showData.hosted_buyer === "active") ?
        <div>
          {formOpen ?
            <Container fluid className='py-4 px-5' style={{ backgroundColor: '#f4f6f9' }}>
              <Row>
                <Col lg={8} className="text-dark">
                  <div className="stepper-wrapper mt-2">
                    <div className={`stepper-item ${formStep >= 1 ? 'completed' : ''} ${formStep === 1 ? 'active' : ''}`}>
                      <div className="step-counter">{formStep > 1 ? <FaCheck /> : '1'}</div>
                      <div className="step-name">Company/Personal<br />Details</div>
                    </div>
                    <div className={`stepper-item ${formStep >= 2 ? 'completed' : ''} ${formStep === 2 ? 'active' : ''}`}>
                      <div className="step-counter">{formStep > 2 ? <FaCheck /> : '2'}</div>
                      <div className="step-name">Upload ID/Photo<br />Documents</div>
                    </div>
                    <div className={`stepper-item ${formStep >= 3 ? 'completed' : ''} ${formStep === 3 ? 'active' : ''}`}>
                      <div className="step-counter">{formStep > 3 ? <FaCheck /> : '3'}</div>
                      <div className="step-name">Travel & Accommodation<br />Details</div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <p className="fw-bold mb-1 text-dark">Note** Application will not be applicable for Jaipur Residents</p>
                    <p className="fw-bold text-dark">Note** The registration confirmation is subject to the approval by the organising committee</p>
                  </div>

                  {formStep === 1 &&
                    <div>
                      <Form onSubmit={handleSubmit} className='px-4' noValidate>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Your Name <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                value={formData.name}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.name && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Mobile <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="tel"
                                name="mobile"
                                placeholder="Enter Mobile"
                                value={formData.mobile}
                                onChange={handleMobileNoChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.mobile && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                              {duplicateError && <span className='text-danger'>This Number is already exists</span>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                placeholder="Enter Email"
                                value={formData.email}
                                onChange={handleEmailChange}
                                onBlur={() => setEmailTouched(true)}
                                required
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.email && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                              {(isSubmitAttempted || emailTouched) && emailError && <span className='text-danger'>{emailError}</span>}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>
                                {nriOrIndian === "NRI" ? (
                                  <>Vat Number</>
                                ) : (
                                  <>GST Number <span className="text-danger">*</span></>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="gstNumber"
                                placeholder={nriOrIndian === "NRI" ? "Enter Vat Number" : "Enter GST Number"}
                                value={formData.gstNumber}
                                onChange={handleGstNumberChange}
                                onBlur={() => setGstTouched(true)}
                                required={nriOrIndian === "Indian"}
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && nriOrIndian === "Indian" && !formData.gstNumber && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                              {nriOrIndian === "Indian" && (isSubmitAttempted || gstTouched) && showError !== '' && <span className='text-danger'>{showError}</span>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Company <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="company"
                                placeholder="Enter Company"
                                value={formData.company}
                                onChange={handleInputChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.company && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Country <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="country"
                                placeholder="Enter Country"
                                value={formData.country}
                                onChange={handleInputChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.country && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="address"
                                placeholder="Enter Address"
                                value={formData.address}
                                onChange={handleInputChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.address && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>City <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="city"
                                placeholder="Enter City"
                                value={formData.city}
                                onChange={handleInputChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.city && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Pincode <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type={nriOrIndian === "NRI" ? "text" : "number"}
                                name="pincode"
                                placeholder="Enter pincode"
                                value={formData.pincode}
                                onChange={handleInputChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.pincode && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>State <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="state"
                                placeholder="Enter state"
                                value={formData.state}
                                onChange={handleInputChange}
                                required
                                disabled={formData.mobile.length === 10 && formOpen && gstAdded}
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.state && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className='mb-3'>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Designation <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                as="select"
                                name="designation"
                                value={formData.designation}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              >
                                <option value="">Select designation</option>
                                <option value="Owner">Owner</option>
                                <option value="Representative">Representative</option>
                              </Form.Control>
                              {isSubmitAttempted && !formData.designation && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-1 mt-4">
                          <Col>
                            <h5 className="text-dark fw-bold mb-3">Select Exhibitor</h5>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Exhibitor 1 <span className="text-danger">*</span></Form.Label>
                              <Select
                                options={exhibitorList.filter(opt => opt.stall_category === "Exhibitor Agency")}
                                value={exhibitorList.find(opt => opt.value === formData.exhibitor_one) || null}
                                onChange={(selectedOption) => {
                                  setFormData(prev => ({
                                    ...prev,
                                    exhibitor_one: selectedOption ? selectedOption.value : ''
                                  }));
                                }}
                                styles={customSelectStyles}
                                isSearchable
                                placeholder="Select Exhibitor 1"
                              />
                              <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0, width: 0, position: 'absolute' }}
                                value={formData.exhibitor_one}
                                required
                                onChange={() => {}}
                              />
                              {isSubmitAttempted && !formData.exhibitor_one && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Exhibitor 2 <span className="text-danger">*</span></Form.Label>
                              <Select
                                options={exhibitorList.filter(opt => opt.stall_category === "Exhibitor Agency")}
                                value={exhibitorList.find(opt => opt.value === formData.exhibitor_two) || null}
                                onChange={(selectedOption) => {
                                  setFormData(prev => ({
                                    ...prev,
                                    exhibitor_two: selectedOption ? selectedOption.value : ''
                                  }));
                                }}
                                styles={customSelectStyles}
                                isSearchable
                                placeholder="Select Exhibitor 2"
                              />
                              <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0, width: 0, position: 'absolute' }}
                                value={formData.exhibitor_two}
                                required
                                onChange={() => {}}
                              />
                              {isSubmitAttempted && !formData.exhibitor_two && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>
                              )}
                              {isSubmitAttempted && formData.exhibitor_one && formData.exhibitor_two && formData.exhibitor_one === formData.exhibitor_two && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>Exhibitor 1 and Exhibitor 2 must be different</div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-1 mt-4">
                          <Col>
                            <h5 className="text-dark fw-bold mb-3">Postal Address (For sending Show Badges)</h5>
                            <Form.Check
                              type="checkbox"
                              id="sameAsGstAddress"
                              label="Same as GST address"
                              className="text-dark mb-2"
                              checked={formData.sameAddress}
                              onChange={handleCommunicationAddress}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="commAddress"
                                placeholder="Enter Communication Address"
                                value={formData.commAddress}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.commAddress && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>City <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="commCity"
                                placeholder="Enter Communication City"
                                value={formData.commCity}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.commCity && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Pincode <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type={nriOrIndian === "NRI" ? "text" : "number"}
                                name="commPincode"
                                placeholder="Enter Communication Pincode"
                                value={formData.commPincode}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.commPincode && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>State <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="text"
                                name="commState"
                                placeholder="Enter state"
                                value={formData.commState}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              />
                              {isSubmitAttempted && !formData.commState && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>This is required</div>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <div className="mb-5">
                          <Button
                            variant="warning"
                            type="submit"
                            className="px-4 py-2"
                            style={{ backgroundColor: '#D6A955', borderColor: '#D6A955' }}
                          >
                            Next
                          </Button>
                        </div>
                      </Form>
                    </div>
                  }

                  {formStep === 2 &&
                    <div>
                      <Form onSubmit={handleSubmit} className='px-4' noValidate>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Upload Photo <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="file"
                                name="photo"
                                accept=".png, .jpg, .jpeg"
                                onChange={handleFileChange}
                                required={dataPresent.photo !== null && dataPresent.photo !== 'null' ? false : true}
                                className="border-warning custom-input"
                              />

                              {renderPreview('photo', dataPresent.photo, 'photo')}
                              {isSubmitAttempted && !formData.photo && (!dataPresent.photo || dataPresent.photo === 'null') && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                  This is required
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>ID Proof (Front) <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="file"
                                name="idProofFront"
                                accept=".png, .jpg, .jpeg"
                                onChange={handleFileChange}
                                required={dataPresent.id_proof_front !== null && dataPresent.id_proof_front !== 'null' ? false : true}
                                className="border-warning custom-input"
                              />

                              {renderPreview('idProofFront', dataPresent.id_proof_front, 'id_proof')}
                              {isSubmitAttempted && !formData.idProofFront && (!dataPresent.id_proof_front || dataPresent.id_proof_front === 'null') && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                  This is required
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-5">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>ID Proof (Back) <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="file"
                                name="idProofBack"
                                accept=".png, .jpg, .jpeg"
                                onChange={handleFileChange}
                                required={dataPresent.id_proof_back !== null && dataPresent.id_proof_back !== 'null' ? false : true}
                                className="border-warning custom-input"
                              />

                              {renderPreview('idProofBack', dataPresent.id_proof_back, 'id_proof')}
                              {isSubmitAttempted && !formData.idProofBack && (!dataPresent.id_proof_back || dataPresent.id_proof_back === 'null') && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                  This is required
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          {/* <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>Upload GST Certificate <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="file"
                                name="gstCertificate"
                                accept=".png, .jpg, .jpeg"
                                onChange={handleFileChange}
                                required
                                className="border-warning custom-input"
                              />
                            </Form.Group>
                          </Col> */}
                        </Row>

                        <div className="mb-5">
                          <Button
                            className="px-4 py-2 mx-2"
                            style={{ backgroundColor: 'black', borderColor: '#D6A955', color: 'white' }}
                            onClick={() => setFormStep(1)}
                          >
                            Back
                          </Button>

                          <Button
                            variant="warning"
                            type="submit"
                            className="px-4 py-2"
                            style={{ backgroundColor: '#D6A955', borderColor: '#D6A955' }}
                            disabled={isLoading}
                          >
                            {isLoading ? <Spinner animation="border" size="sm" /> : "Next"}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  }

                  {formStep === 3 &&
                    <div>
                      <Form onSubmit={handleSubmit} className='px-4' noValidate>
                        <Row className="mb-1">
                          <Col>
                            <h5 className="text-dark fw-bold mb-3">Arrival Travel Information</h5>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Arrival Mode (Flight / Train / Self) <span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                as="select"
                                name="arrivalMode"
                                value={formData.arrivalMode}
                                onChange={handleInputChange}
                                required
                                className="border-warning custom-input"
                              >
                                <option value="">Select Mode</option>
                                <option value="Flight">Flight</option>
                                <option value="Train">Train</option>
                                <option value="Self">Self</option>
                              </Form.Control>
                              {isSubmitAttempted && !formData.arrivalMode && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                  This is required
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          {formData.arrivalMode &&
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>Arrival From - City <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                  type="text"
                                  name="arrivalFrom"
                                  placeholder="Enter Arrival City"
                                  value={formData.arrivalFrom}
                                  onChange={handleInputChange}
                                  required
                                  className="border-warning custom-input"
                                />
                                {isSubmitAttempted && !formData.arrivalFrom && (
                                  <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                    This is required
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          }
                        </Row>

                        {formData.arrivalMode &&
                          <div>
                            <Row className="mb-3">
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Arrival Date <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="date"
                                    name="arrivalDate"
                                    value={formData.arrivalDate}
                                    onChange={handleInputChange}
                                    required
                                    className="border-warning custom-input"
                                    min="2026-06-30"
                                    max="2026-07-05"
                                  />
                                  {isSubmitAttempted && !formData.arrivalDate && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      This is required
                                    </div>
                                  )}
                                  {isDateInvalid(formData.arrivalDate) && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      Please pick date between 30th June to 5th July 2026
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Arrival Time <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="time"
                                    name="arrivalTime"
                                    value={formData.arrivalTime}
                                    onChange={handleInputChange}
                                    required
                                    className="border-warning custom-input"
                                  />
                                  {isSubmitAttempted && !formData.arrivalTime && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      This is required
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>

                            {formData.arrivalMode !== 'Self' &&
                              <Row className="mb-3">
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Mode Details (Flight No. / Train No.) <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="modeDetails"
                                      placeholder="Enter Mode Details"
                                      value={formData.modeDetails}
                                      onChange={handleInputChange}
                                      required
                                      className="border-warning custom-input"
                                    />
                                    {isSubmitAttempted && !formData.modeDetails && (
                                      <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                        This is required
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>

                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Upload Ticket <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                      type="file"
                                      name="ticket"
                                      accept=".png, .jpg, .jpeg, .pdf"
                                      onChange={handleFileChange}
                                      required={dataPresent.upload_ticket != null && dataPresent.upload_ticket !== 'null' ? false : true}
                                      className="border-warning custom-input"
                                    />

                                    {renderPreview('ticket', dataPresent.upload_ticket, 'tickets')}
                                    {isSubmitAttempted && !formData.ticket && (!dataPresent.upload_ticket || dataPresent.upload_ticket === 'null') && (
                                      <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                        This is required
                                      </div>
                                    )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            }
                          </div>
                        }

                        <Row className="mb-4">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>
                                Stay Duration <span className="text-danger">*</span>
                              </Form.Label>
                              <div>
                                <Form.Check
                                  inline
                                  label="1 Night"
                                  type="radio"
                                  name="stayOption"
                                  value="1"
                                  checked={stayOption === "1"}
                                  onChange={(e) => {
                                    setStayOption(e.target.value);
                                    setFormData((prev) => ({ ...prev, stayDuration: "" }));
                                  }}
                                />
                                <Form.Check
                                  inline
                                  label="2 Nights"
                                  type="radio"
                                  name="stayOption"
                                  value="2"
                                  checked={stayOption === "2"}
                                  onChange={(e) => {
                                    setStayOption(e.target.value);
                                    setFormData((prev) => ({ ...prev, stayDuration: "" }));
                                  }}
                                />
                              </div>
                              {isSubmitAttempted && !stayOption && (
                                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                  This is required
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>

                        {stayOption && (
                          <Row className="mb-4">
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Select Date <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="stayDuration"
                                  value={formData.stayDuration}
                                  onChange={handleInputChange}
                                  required
                                  className="border-warning custom-input"
                                >
                                  <option value="">Select Date</option>
                                  {(stayOption === "1" ? oneNightOptions : twoNightOptions).map(
                                    (option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    )
                                  )}
                                </Form.Control>
                                {isSubmitAttempted && !formData.stayDuration && (
                                  <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                    This is required
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        )}

                        <Row className="mb-1">
                          <Col>
                            <h5 className="text-dark fw-bold mb-3">Departure Travel Information (If requires Cab for logistics)</h5>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Cab Required? <span className="text-danger">*</span></Form.Label>
                              <Form.Check
                                type="radio"
                                name="cabRequired"
                                label="Yes"
                                value="Yes"
                                onChange={handleRadioChange}
                                checked={formData.requiresCab === 'Yes'}
                                className="text-dark"
                              />
                              <Form.Check
                                type="radio"
                                name="cabRequired"
                                label="No"
                                value="No"
                                onChange={handleRadioChange}
                                checked={formData.requiresCab === 'No'}
                                className="text-dark"
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        {formData.requiresCab === 'Yes' &&
                          <div>
                            <Row className="mb-3">
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Departure Date<span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="date"
                                    name="departureDate"
                                    value={formData.departureDate}
                                    onChange={handleInputChange}
                                    required
                                    className="border-warning custom-input"
                                    min="2026-06-30"
                                    max="2026-07-06"
                                  />
                                  {isSubmitAttempted && !formData.departureDate && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      This is required
                                    </div>
                                  )}
                                  {isDateInvalid(formData.departureDate, true) && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      Please pick date between 30th June to 6th July 2026
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Departure Time from Hotel<span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="time"
                                    name="departureTime"
                                    value={formData.departureTime}
                                    onChange={handleInputChange}
                                    required
                                    className="border-warning custom-input"
                                  />
                                  {isSubmitAttempted && !formData.departureTime && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      This is required
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="mb-4">
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Departure Mode<span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="departureMode"
                                    value={formData.departureMode}
                                    onChange={handleInputChange}
                                    required
                                    className="border-warning custom-input"
                                  >
                                    <option value="">Select Mode</option>
                                    <option value="Flight">Flight</option>
                                    <option value="Train">Train</option>
                                    <option value="Self">Self</option>
                                  </Form.Control>
                                  {isSubmitAttempted && !formData.departureMode && (
                                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                                      This is required
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>
                        }

                        <div className="mb-5">
                          <Button
                            className="px-4 py-2 mx-2"
                            style={{ backgroundColor: 'black', borderColor: '#D6A955', color: 'white' }}
                            onClick={() => setFormStep(2)}
                          >
                            Back
                          </Button>

                          <Button
                            variant="warning"
                            type="submit"
                            className="px-4 py-2"
                            style={{ backgroundColor: '#D6A955', borderColor: '#D6A955' }}
                            disabled={isLoading}
                          >
                            {isLoading ? <Spinner animation="border" size="sm" /> : "Submit"}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  }
                </Col>

                <Col lg={4} className="ps-4" style={{ borderLeft: '1px solid #D6A955' }}>
                  <div className="text-center mb-4">
                    <Card className="custom-side-card">
                      <Card.Body>
                        <div className="mb-3">
                          <h5>
                            <Link to="https://jasjaipur.com/at-a-glance" className="text-decoration-none text-dark">At a Glance</Link> /{' '}
                            <Link to="https://jasjaipur.com/history" className="text-decoration-none text-dark">History</Link> /{' '}
                            <Link to="https://jasjaipur.com/tourist-spots" className="text-decoration-none text-dark">Tourist Spots</Link> /{' '}
                            <Link to="https://jasjaipur.com/entertainment" className="text-decoration-none text-dark">Entertainment</Link>
                          </h5>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>

                  <div className="text-center mb-4">
                    <Card className="custom-side-card">
                      <Card.Body>
                        <div className="mb-3">
                          <h5>
                            <Link to="https://jasjaipur.com/official-hotels" className="text-decoration-none text-dark">Official Hotels</Link> /{' '}
                            <Link to="https://jasjaipur.com/air-info" className="text-decoration-none text-dark">Air Info</Link> /{' '}
                            <Link to="https://jasjaipur.com/rail-info" className="text-decoration-none text-dark">Rail Info</Link> /{' '}
                            <Link to="https://jasjaipur.com/road-info" className="text-decoration-none text-dark">Road Info</Link>
                          </h5>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>

                  <div className="text-center mb-4">
                    <Card className="custom-side-card">
                      <Card.Body>
                        <div className="mb-3">
                          <h5>
                            <Link to="https://jasjaipur.com/restaurant-info" className="text-decoration-none text-dark">Restaurant Info</Link> /{' '}
                            <Link to="https://jasjaipur.com/venue" className="text-decoration-none text-dark">Venue</Link>
                          </h5>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Container> :
            <div className="py-4">
              <div className="container">
                {!gstForm ?
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <div className="text-center mb-4">
                        <h4 className="form-heading">Hosted Buyer Additional Details</h4>
                      </div>

                      <form onSubmit={handleCheckNoIsPresentOrNot} className="p-4 border rounded shadow-sm bg-light">
                        <div className="mb-3">
                          <label htmlFor="number" className="form-label">
                            Enter Phone Number
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Hosted Buyer Contact Number"
                            id="number"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="d-grid">
                          <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? <Spinner animation="border" size="sm" /> : 'Submit'}
                          </button>
                        </div>
                        {isAlreadyApproved && (
                          <div className="mt-4 p-3 rounded" style={{ backgroundColor: '#e6f4ea', border: '1px solid #ceead6', display: 'flex', alignItems: 'center' }}>
                            <div className="me-3 text-success">
                              <FaCheckCircle size={28} />
                            </div>
                            <div>
                              <p className="mb-1 text-dark fw-bold" style={{ fontSize: '1.05rem' }}>You are already a Approved Hosted buyer.</p>
                              <p className="mb-0 text-muted" style={{ fontSize: '0.9rem' }}>
                                For any further changes, you can contact on - <a href="tel:+919785610067" className="text-decoration-none fw-bold" style={{ color: '#137333' }}>+91 9785610067</a>
                              </p>
                            </div>
                          </div>
                        )}
                      </form>

                    </div>
                  </div> :
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <div className="text-center mb-4">
                        <h4 className="form-heading">Hosted Buyer GST Details</h4>
                      </div>

                      <form onSubmit={storeGstDetails} className="p-4 border rounded shadow-sm bg-light">
                        <div className="mb-3">
                          <label htmlFor="number" className="form-label">
                            Enter Phone Number
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Hosted Buyer Contact Number"
                            id="number"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            required
                            disabled={true}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-bold">Country <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Country"
                            name="country"
                            value={formData.country}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <Row className="mb-3">
                          <Col md={12}>
                            <Form.Group>
                              <Form.Label>
                                {nriOrIndian === "NRI" ? (
                                  <>Vat Number</>
                                ) : (
                                  <>GST Number <span className="text-danger">*</span></>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="gstNumber"
                                placeholder={nriOrIndian === "NRI" ? "Enter Vat Number" : "Enter GST Number"}
                                value={formData.gstNumber}
                                onChange={handleGstNumberChange}
                                onBlur={() => setGstTouched(true)}
                                required={nriOrIndian === "Indian"}
                                className="border-warning"
                              />
                              {nriOrIndian === "Indian" && (isSubmitAttempted || gstTouched) && showError !== '' && <span className='text-danger'>{showError}</span>}
                            </Form.Group>
                          </Col>
                        </Row>

                        <div className="d-grid">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isLoading ? true : false}
                          >
                            {isLoading ? <Spinner /> : 'Submit'}
                          </button>
                        </div>
                      </form>

                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div> :
        <div className="py-4">
          <div className="container">

            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="text-center mb-4">
                  <h4 className="form-heading">Hosted Buyer GST Details</h4>
                </div>

                <div className='text-center text-danger'>
                  <h5>Portal is Closed</h5>
                  <p className='text-muted'>Please contact +91 9785610067 for further assistance.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      }


      <footer className="bg-dark text-white pt-5 pb-3">
        <Container>
          <Row className="mb-4">
            <Col lg={5} className="mb-4">
              <div className="mb-3">
                <img src={logoImage} width={'150px'} />
              </div>
              <p className='text-white' style={{ width: "300px" }}>
                Initiated by the Jewellers Association, Jaipur, JAS is India's top-of-the-line gemstone and jewellery show.
              </p>
            </Col>

            <Col lg={3} className="mb-4">
              <h5 className="mb-3">QUICK LINKS</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="https://jasjaipur.com/" className="text-white text-decoration-none">Home</a></li>
                <li className="mb-2"><a href="https://jasjaipur.com/about-jas/" className="text-white text-decoration-none">About us</a></li>
                <li className="mb-2"><a href="https://jasjaipur.com/gallery/" className="text-white text-decoration-none">Gallery</a></li>
                <li className="mb-2"><a href="https://jasjaipur.com/press-room/" className="text-white text-decoration-none">Press room</a></li>
                <li className="mb-2"><a href="https://jasjaipur.com/contact-us/" className="text-white text-decoration-none">Contact us</a></li>
              </ul>
            </Col>

            <Col lg={3}>
              <h5 className="mb-3">CONNECT WITH US</h5>
              <address className="text-white">
                252, Jewellers Association Building,<br />
                Johari Bazar, Jaipur, Rajasthan, Pincode-302003<br />
                0141-2563839, 4034112<br />
                <a href="mailto:info@jasjaipur.com" className="text-white text-decoration-none">info@jasjaipur.com</a>
              </address>

              <div className="d-flex gap-2 mt-3">
                <a href="https://www.facebook.com/jasrajasthan/" className="btn btn-secondary btn-sm rounded-circle">
                  <FaFacebookF />
                </a>
                <a href="https://www.instagram.com/jasrajasthan/" className="btn btn-secondary btn-sm rounded-circle">
                  <FaInstagram />
                </a>
                <a href="https://x.com/jas_rajasthan" className="btn btn-secondary btn-sm rounded-circle">
                  <FaTwitter />
                </a>
                <a href="https://www.youtube.com/channel/UCiwv7f9NNAOk3TRIcJqTo0A" className="btn btn-secondary btn-sm rounded-circle">
                  <FaYoutube />
                </a>
              </div>
            </Col>
          </Row>

          <hr className="border-secondary" />

          <Row className="align-items-center">
            <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
              <small>© Copyright {process.env.REACT_APP_ORGANIZER_NAME} 2026. All Rights Reserved</small>
            </Col>
            <Col md={4} className="text-center mb-3 mb-md-0">
              <small>Designed by {process.env.REACT_APP_ORGANIZER_NAME}</small>
            </Col>
            <Col md={4} className="text-center text-md-end">
              <small>Developed by {process.env.REACT_APP_ORGANIZER_NAME}</small>
            </Col>
          </Row>
        </Container>
      </footer>

      <style jsx>{`
            .visitor-registration-page {
                font-family: 'Arial', sans-serif;
            }
            .header-bg {
                background-color: #8a6d3b;
            }
            .border-warning {
                border-color: #D6A955 !important;
            }
            .btn-warning {
                background-color: #D6A955;
                border-color: #D6A955;
            }
            .text-warning {
                color: #D6A955 !important;
            }
            .custom-input {
                background-color: #fff !important;
                color: black !important;
                border-color: #ffc107;
            }
            .custom-input:disabled {
                background-color: #e9ecef !important;
                color: #6c757d !important;
                opacity: 0.7;
                cursor: not-allowed;
            }
            .custom-input::placeholder {
                color: #666 !important;
                opacity: 0.8;
            }
            .custom-side-card {
                background-color: transparent !important;
                color: black;
                border-color: #D6A955;
                border-radius: 2px;
            }
            .card-body div h5 a {
                color: black !important;
            }
            .custom-dropdown .dropdown-submenu {
                position: relative;
            }
            .custom-dropdown .nested-dropdown .dropdown-menu {
                top: 0;
                left: 100%;
                color: #D6A955;
            }
            .custom-dropdown .dropdown-menu {
                border-radius: 0;
                margin-top: 0;
                border: none;
                box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            }
            .dropdown-submenu > .dropdown-menu {
                display: none;
                position: absolute;
                left: 100%;
                top: 0;
            }
            .dropdown-submenu:hover > .dropdown-menu {
                display: block;
            }
            .dropdown-submenu .dropdown-toggle::after {
                margin-left: 0.5em;
            }
        `}</style>
    </div>
  );
};

export default BuyerRegistrationForm;
